import { Component, OnInit } from '@angular/core';
import { OnDestroyHookDirective } from '../../hooks';
import { Store } from '@ngrx/store';
import {
  ApplicationState,
  getAllDeepLinkProducts,
} from '../../../store/reducers';
import {
  DeepLinkStatus,
  getIcon,
  InternetProduct,
  MobileProduct,
  Product,
  TvProduct,
} from '@dch/products-business-logic';
import { TranslationService } from '@proximus/ng-common';
import { SelectDeepLinkProduct } from '../../../store/actions/product-selector.actions';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

const DEFAULT_SIZE = 6;
const DEFAULT_PAGE = 0;

@Component({
  selector: 'mprd-product-selector',
  templateUrl: './product-selector.component.html',
  styleUrls: ['./product-selector.component.css'],
})
export class ProductSelectorComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  public products: Array<MobileProduct | InternetProduct | TvProduct>;
  public productsPagination: Array<MobileProduct | InternetProduct | TvProduct>;
  public selectedProduct: MobileProduct | InternetProduct | TvProduct;
  pageForm: UntypedFormGroup;
  page = DEFAULT_PAGE;
  destroy: () => void;
  pages!: number[];
  ofNPages: string;

  DeepLinkStatus = DeepLinkStatus;

  constructor(
    private store: Store<ApplicationState>,
    private translationService: TranslationService,
    private formBuilder: UntypedFormBuilder,
  ) {
    super();
  }

  ngOnInit(): void {
    this.addSubscription(
      this.store.select(getAllDeepLinkProducts).subscribe((products) => {
        this.products = products;
        this.productsPagination = this.sliceProductsList(0);
        this.page = 0;
        this.pages = products ? this.fillPages(products.length) : [];
        this.buildOfNPagesTranslation();
      }),
    );
    this.store.dispatch(new SelectDeepLinkProduct(undefined));
    this.pageForm = this.formBuilder.group({
      pageControl: [DEFAULT_PAGE],
    });
  }

  selectProduct(product) {
    this.selectedProduct = product;
  }

  fillPages(total: number): number[] {
    return Array(Math.ceil(total / DEFAULT_SIZE))
      .fill(0)
      .map((x, i) => i);
  }

  onPageChange(page: string) {
    this.goToPage(parseInt(page, 10));
  }

  sliceProductsList(page: number) {
    const start = page * DEFAULT_SIZE;
    const end = page * DEFAULT_SIZE + DEFAULT_SIZE;
    return this.products ? this.products.slice(start, end) : [];
  }

  buildOfNPagesTranslation() {
    this.ofNPages = this.translationService
      .getTranslatedValueFor('product.selector.deepLink.ofNPages')
      .replace('{0}', this.pages.length);
  }

  close() {
    this.destroy();
  }

  goToNextPage() {
    this.goToPage(this.page + 1);
  }

  goToPreviousPage() {
    this.goToPage(this.page - 1);
  }

  goToPage(page: number) {
    this.page = page;
    this.pageForm = this.formBuilder.group({
      pageControl: [this.page],
    });
    this.productsPagination = this.sliceProductsList(this.page);
  }

  confirm() {
    this.store.dispatch(new SelectDeepLinkProduct(this.selectedProduct));
    this.destroy();
  }

  getDeepLinkStatusMessage(
    product: MobileProduct | InternetProduct | TvProduct,
  ): string {
    let message;
    if (product.deepLinkStatus) {
      if (
        product.deepLinkStatus ===
        DeepLinkStatus.DEEPLINK_OPTION_ORDERING_ALREADY_ACTIVE
      ) {
        message = this.translationService.getTranslatedValueFor(
          'product.selector.deepLink.active',
        );
      } else if (
        product.deepLinkStatus ===
        DeepLinkStatus.DEEPLINK_OPTION_ORDERING_INCOMPATIBLE
      ) {
        message = this.translationService.getTranslatedValueFor(
          'product.selector.deepLink.incompatible',
        );
      }
    }
    return message;
  }

  getIcon(product: Product): string {
    return getIcon(product);
  }
}
